import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { map } from 'rxjs';

import { salesProductsApiActions } from './sales-products.actions';
import { selectSalesProducts, selectSalesProductsError, selectSalesProductsLoaded } from './sales-products.selectors';

@Injectable()
export class SalesProductsFacade {
  private store = inject(Store);

  loaded$ = this.store.pipe(select(selectSalesProductsLoaded));
  error$ = this.store.pipe(select(selectSalesProductsError));
  salesProducts$ = this.store.pipe(select(selectSalesProducts));
  hasApiToken$ = this.salesProducts$.pipe(map((salesProducts) => salesProducts?.hasApiToken));
  hasScanUserAccess$ = this.salesProducts$.pipe(map((salesProducts) => salesProducts?.hasScanUserAccess));

  loadSalesProducts(): void {
    this.store.dispatch(salesProductsApiActions.loadSalesProducts());
  }
}
